import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { HelperService, HTTPService, DataService, CalculationService, FormatService } from 'app/services';
import { config, messages } from 'app/constants';

import { UpdateCannedServiceDialogComponent } from 'app/modules/app-components/update-canned-service-dialog/update-canned-service-dialog.component';
import { DeleteCategoryDialogComponent } from '../delete-category-dialog/delete-category-dialog.component';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { currency } from 'app/constants/currency.constants';

import { find, debounce, orderBy, findIndex } from 'lodash';
import { LocationAddComponent } from '../location-add/location-add.component';
import { Subscription } from 'rxjs';
import { QtyOnEstimateListModalComponent } from '../qty-on-estimate-list-modal/qty-on-estimate-list-modal.component';

@Component({
  selector: 'app-part-add',
  templateUrl: './part-add.component.html',
  styleUrls: ['./part-add.component.scss'],
  providers: [DialogService],
  animations: [
    trigger('toggleBox', [
      state(
        'open',
        style({
          height: '135px',
        }),
      ),
      state(
        'closed',
        style({
          height: '0px',
        }),
      ),
      transition('open => closed', [animate('0.0s')]),
      transition('closed => open', [animate('0.0s')]),
    ]),
  ],
})
export class PartAddComponent implements OnInit, OnChanges {
  @Input() categoryType: string = '';
  @Input() categories: any[] = [];
  @Input() suppliers: any[] = [];
  @Input() locations: any[] = [];
  @Input() qboItemRefs: any[] = [];
  @Input() pricings: any[] = [];
  @Input() pricingRules: any[] = [];
  @Input() isLoading: boolean = false; // don't set this key inside this component
  @Input() data: any = {};
  @Input() item: any = {};
  @Input() stock: any = {};
  @Input() partId: string = '';
  @Input() isLocal: boolean = true;
  @Input() isQboConnected: boolean = false;
  @Input() isOpenFromPO: boolean = false;
  @Input() isInventoryEnabled: boolean = false;
  @Input() poDetails: any = {};
  @Input() isTaxable: boolean = false;
  @Input() orderServiceItemIndex: number = -1;
  @Input() orderServiceId: string = '';
  @Input() openFrom: string = '';
  @Input() serviceItem: any = {};
  @Input() averageCost: number = 0;
  @Input() latestPoCost: number = 0;
  @Input() defaultTaxable: boolean = false;
  @Input() isOpenFromRO: boolean = false;
  @Input() isOpenFromMO: boolean = false;
  @Input() orderId: string = '';
  @Input() isFeeAssociationEnabled: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() isMarkAsInventoryEnabled: boolean = false;
  @Input() isPreFilledPartFields: boolean = false;
  @Input() isOnlineInvOrderEnabled: boolean = false;
  @Input() isFinalizedRo: boolean = false;
  @Input() canEditClassifications: boolean = false;
  @Input('titleForCreate')
  set titleForCreate(title: any) {
    if (title) {
      this.handleChange('name', title);

      const query = { title: title.trim(), type: 'part', code: '' };

      if (this.helperService.trimString(this.part.number)) query.code = this.part.number.trim();

      this.httpService.isItemTitleUnique(query, this.partId).then(
        (res) => {
          if (res.duplicateItems && res.duplicateItems.length) {
            this.errors.number = 'Other matches found for this Item #';
            this.createItemNumberTooltip(res.duplicateItems);
          } else {
            this.errors.number = '';
          }
          if (!res.data) {
            this.errors.name = 'Part name must be unique';
            this.isTitleUnique = false;
            this.helperService.showToaster('error', 'Part name must be unique');
          } else {
            this.errors.name = '';
            this.isTitleUnique = true;
          }
        },
        (err) => {
          console.error(err);
        },
      );
    }
  }
  @Input() isPricingMatricesManagement: boolean = false;
  @Input() isPricingManagementEnable: boolean = false;
  @Input() isNewItemCategoriesEnable: boolean = false;
  @Input() isAttributeBasedPricingEnable: boolean = false;
  @Input() isOpenFromST: boolean = false;
  @Input() cardGroupIndex: number = -1;
  @Input() isPartWarrantiesEnabled: boolean = false;

  @Output() handleClose = new EventEmitter<any>();

  @ViewChild('partBody', { static: true }) partBody: ElementRef;

  selectedFilterOptionLength: number;
  filter: any = {};
  selectedTab: number = 0;
  activityLog: any = {};
  isQuickbooksConnected: boolean = false;
  activeInput: string = 'name';
  part: any = {
    _id: '',
    name: '',
    titleFR: '',
    category: { name: '' },
    cost: '',
    price: '',
    supplier: { name: '' },
    number: '',
    pricing: {},
    description: '',
    descriptionFR: '',
    internalNotes: '',
    isTaxable: true,
    displayHoursOnOrder: true,
    displayDescOnOrder: true,
    commissionable: true,
    status: true,
    itemRef: {},
    locationQboItemRefId: {},
    hasCore: false,
    coreCost: '',
    isChangeInPriceMatrix: false,
  };
  activeStatus: any = true;
  errors: any = {
    name: '',
    titleFR: '',
    category: '',
    cost: 0,
    price: 0,
    supplier: '',
    number: '',
    pricing: '',
    description: '',
    descriptionFR: '',
    internalNotes: '',
    categoryId: '',
    supplierId: '',
    restockLevel: '',
    location: '',
    coreCost: '',
  };
  focus: any = {
    name: true,
  };
  duplicateItemNumberTooltip: any = '';

  tableConfig = {
    offset: 0,
    limit: config.pageSize,
    sortField: 'title',
    sortOrder: 1,
    search: '',
  };
  costOptions: any[] = [
    { label: 'Cost', value: 'cost', statusActive: true },
    { label: 'Avg. Cost', value: 'avg', statusActive: true },
    { label: 'Latest PO', value: 'latestPo', statusActive: true },
  ];

  filterOptionModel = {
    itemHistory: false,
    purchaseHistory: false,
    sellingHistory: false,
    pricingHistory: false,
  };
  filterOption: any[] = [];
  categoryResults: any[] = [];
  pricingMatrixResults: any[] = [];
  suppliersResults: any[] = [];
  locationsResults: any[] = [];
  calculatedAmount: any;
  partType = 'part';
  oldPartNumber: string = '';
  isProcessing: boolean = false;
  hazmatFeeObject: any = {};
  hazmatFeeArray: any[] = [];
  itemResults: any[] = [[]];
  isSearching: boolean = false;
  usd: string = currency.USD;
  config: any = config;
  pricing: any;
  isCreateMultiple: boolean = false;
  isTitleUnique: boolean = true;
  updateGenericItem: boolean = false;
  checkUniqueTitle = debounce(this._checkUniqueTitle, 600);
  checkUniqueCategory = debounce(this._checkUniqueCategory, 600);
  defaultQboItems: any[] = [];
  // used to maintain state changes for each component
  initalInputStates = <any>{};
  updatedInputStates = <any>{};
  defaultActiveState: boolean = true;
  isPartsOrderingItem: boolean = false;
  defaultHasCore: boolean = false;
  categoryName: any = '';
  isShowError: boolean = false;
  categorId: any = '';
  whichPricingMatrixUsed: any = '';
  isChangeInPriceMatrix: boolean = false;
  isMultiLocationEnabled: boolean = false;
  isStockTransferEnabled: boolean = false;
  isNewCategoriesEnabled: boolean = false;
  isSalesCodeEnabled: boolean = false;
  matrix = <any>{};
  pricingMatrixList: any[] = [];
  noMatrix = [
    {
      name: 'No pricing rules',
    },
  ];
  currentShopId: string = '';

  transferOptions: any[] = [
    { label: 'Receive item via transfer', value: 'receiver' },
    { label: 'Send item via transfer', value: 'sender' },
  ];
  activityLogs: any[] = [];
  isFilterLoading = false;
  categoriesSuggestions: any[] = [];
  subCategoriesSuggestions: any[] = [];
  subSubCategoriesSuggestions: any[] = [];
  isLockedRO = false;
  categoriesSuggestionsResults: any[] = [];
  subCategoriesSuggestionsResults: any[] = [];
  subSubCategoriesSuggestionsResults: any[] = [];
  warehouses: any[] = [];
  partStockDetails: any[] = [];
  categoriesList: any = [];
  categoriesResults: any[] = [];
  partstechResults: any = [];
  isDataLoading: boolean = false;
  isCustomerCategory: boolean = false;
  othersResults: any = [];
  selectedValue: any = '';
  selectedLevel: any = '';
  limit: number = 30;
  orderPageIndex: number = 0;
  partsTechPageIndex: number = 0;
  initialPrice: null;
  totalRecords: number = 0;
  loader = {
    category: false,
    subCategory: false,
    subSubCategory: false,
  };
  classificationPrivilegeMsg: string = messages.classificationPrivilegeMsg;
  warrantyTime: any[] = [
    {
      name: 'One Year',
      value: 'oneYear',
    },
    {
      name: '6 Months',
      value: '6months',
    },
  ];

  warrantyMileage: any[] = [
    {
      name: '200 Miles',
      value: '200M',
    },
    {
      name: '12 Kilometers',
      value: '12KM',
    },
  ];
  //salesCodeOverideConfirm: boolean = false;
  defaultSalesCode: any = {};
  isAutoAssign: boolean = false;
  localizationSubscription: Subscription;
  companyLocalization: boolean = false;
  currentLang: string = 'en';
  pricingPrivilege:any = {};

  constructor(
    private helperService: HelperService,
    private httpService: HTTPService,
    private formatService: FormatService,
    public calculationService: CalculationService,
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.isStockTransferEnabled = this.dataService.isStockTransferEnabled;
    this.isMultiLocationEnabled = isMultiLocationEnabled;
    // if (this.partId) {
    //   this.getLogs();
    // }
    this.getLocalizationFlags();
    if (this.isOpenFromRO) {
      this.isLockedRO = this.dataService.isLockedRO;
    }
    if (this.dataService.isNewItemCategoriesEnable) {
      this.searchCategorySuggestion('');
      this.getAllCategories();
    }

    if (this.isStockTransferEnabled && this.isMultiLocationEnabled) {
      this.getWarehouses();
    }

    const employee = this.helperService.deepCopy(this.dataService.currentEmployeeDetails);
    this.pricingPrivilege= employee?.privileges.filter((privilegeItem)=> privilegeItem?.title=== 'pricing-management')[0]
  }

  getLocalizationFlags() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value;
        if (!isMultiLocationEnabled) {
          this.httpService.getCompanyPreferredLanguage().then((res: any) => {
            const lang = res.preferredLanguage;
            if (lang) {
              this.currentLang = lang.toLowerCase();
            }
          });
        } else {
          this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then((company: any) => {
            const lang = company.shop.preferredLanguage;
            if (lang) this.currentLang = lang.toLowerCase();
          });
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
  }

  async getWarehouses() {
    const warehouseData: any = await this.httpService.getWarehouses();
    if (warehouseData.records?.length) {
      this.warehouses = warehouseData.records;
      if (this.warehouses?.length && !this.part.otherLocationDataTooltip && this.partStockDetails?.length) {
        const { otherLocationQty, tooltip } = this.getQtyOtherLocationTooltip();
        this.part.otherLocationDataTooltip = tooltip;
        this.part.otherLocationQty = otherLocationQty;
      }
    }
  }

  ngOnChanges(change: any) {
    const { isLoading } = change;
    if (isLoading) {
      if (isLoading.previousValue && !isLoading.currentValue) {
        if (!this.partId) {
          this.defaultTaxable = this.isTaxable;
          this.part.isTaxable = this.isTaxable;

          if (this.isOpenFromPO && this.isMarkAsInventoryEnabled) {
            this.part.hasMarkedInventory = true;
          }
        }
        this.currentShopId = localStorage.getItem('currentShop') || this.helperService.getCurrentShopId();
        const { isMultiLocationEnabled } = this.helperService.getCompany();
        this.isMultiLocationEnabled = isMultiLocationEnabled;
        this.isAttributeBasedPricingEnable = this.dataService.isAttributeBasedPricingEnable;
        this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
        this.isSalesCodeEnabled = this.dataService.isSalesCodeEnabled;
        // using this key for getting the pricing matrix details so no need to save it again on rules -> default matrix , category overRide matrix
        this.pricingMatrixList = this.helperService.deepCopy(this.pricings);
        if (this.isAttributeBasedPricingEnable) {
          // override with pricing rules
          this.pricings = [...(this.noMatrix || []), ...(this.pricingRules || [])];
        }
        this.setPricingMatrix(this.pricings);
        this.setCategories(this.categories);
        this.setSuppliers(this.suppliers);
        this.setItemDetails(this.item);
        this.initializePricings();
        this.checkPricingBackwardCompatibility();
        this.getLocations();
        this.hazmatFeeArray.push({});
        this.defaultQboItems = this.helperService.deepCopy(this.qboItemRefs);
        this.isProcessing = false;
        this.oldPartNumber = this.part.number || '';
      }
      this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
      this.isStockTransferEnabled = this.dataService.isStockTransferEnabled;
    }
  }

  checkPricingBackwardCompatibility() {
    const currentShopDetails = find(this.part?.shopDetails, { shopId: this.helperService.getCurrentShopId() });
    if (currentShopDetails && this.part?.price !== currentShopDetails?.price && !this.isOpenFromPO && !this.isOpenFromRO && !this.isOpenFromST) {
      this.part.price = currentShopDetails?.price;
    } else {
      if (this.initialPrice && this.part.price !== this.initialPrice && !currentShopDetails && !this.isOpenFromPO && !this.isOpenFromRO && !this.isOpenFromST) {
        this.part.price = this.initialPrice;
      } else if ((this.isOpenFromPO || this.isOpenFromRO || this.isOpenFromST) && this.pricingMatrixResults) {
        const pricingObj = find(this.pricingMatrixResults, { _id: this.serviceItem?.pricing?.pricingId || this.part?.pricing?.pricingId });

        this.pricing = pricingObj;
        if (this.serviceItem?.pricing?.name !== 'No pricing rules') {
          this.part.pricing = pricingObj;
        }

        if (!pricingObj?.pricingId && pricingObj?._id && this.isOpenFromRO) {
          this.part.pricing = {
            name: pricingObj.name,
            pricingId: pricingObj?._id,
          };
        }

        this.calculateMarkup();

        if (this.part.price !== this.initialPrice && !this.isOpenFromPO && !this.isOpenFromRO) {
          this.pricing = {};
          this.part.pricing = {};
        }
        this.part.price = this.initialPrice;
      }
    }
    this.part.totalPrice = this.part.price * this.part.count;
  }

  getLogs() {
    // /appLogs/getByQuery
    const query = <any>{};
    if (this.filterOption?.length) {
      query.entityType = this.filterOption;
    }
    query.entityId = this.partId;
    query.isItemLogs = true;
    this.httpService.getActivityLog(query).then(
      (data: any) => {
        console.log(data);
        if (data) {
          this.activityLogs = this.formatService.formateCatlogActivityLogs(data);
        }
        this.isFilterLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.isFilterLoading = false;
      },
    );
  }

  openAssignSalesCodeDialog() {
    if (!this.canEditClassifications && !this.isOpenFromRO) {
      return;
    }
    const data = {
      item: this.part,
      openFrom: 'old-part-modal',
    };
    data.item.title = data.item?.name || '';
    this.dataService.sendData(this.dataService.typeDialog('open-sales-code-assign-modal', 'old-part-modal', null, null, data));
  }

  onCheckboxChange(event: Event, value) {
    this.selectedFilterOptionLength = 0;

    this.isFilterLoading = true;
    if (event) {
      this.filterOption.push(value);
    } else {
      this.filterOption = this.filterOption.filter((option) => option !== value);
    }

    // add with RO
    if (value === 'ci-purchase-history-po' && event) {
      this.filterOption.push('ci-purchase-history-ro');
    } else if (value === 'ci-purchase-history-po' && !event) {
      this.filterOption = this.filterOption.filter((option) => option !== 'ci-purchase-history-ro');
    }
    this.selectedFilterOptionLength = this.filterOption.length;
    if (this.filterOption.includes('ci-purchase-history-ro')) {
      this.selectedFilterOptionLength = this.selectedFilterOptionLength - 1;
    }

    this.getLogs();
  }

  displaySalesCodeTitle() {
    return this.helperService.displaySalesCodeTitle(this.part.salesCode, this.part.category);
  }

  deleteCategoryDialog(e) {
    this.httpService
      .getAllCategories(e._id)
      .then((data: any) => {
        if (data.length) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'part',
              isOnlyDelete: false,
              count: data.length,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.part && this.part.category?.name === name) {
                this.part.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        } else if (data.length === 0) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'part',
              isOnlyDelete: true,
              count: 0,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.part && this.part.category?.name === name) {
                this.part.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        }
      })
      .catch((err) => this.helperService.showToaster('error', err));

    // const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
    //   width: '1200px',
    //   styleClass: 'add-dialog overflow-initial delete-category-dialog',
    //   showHeader: false,
    //   data: {
    //     selectedCategory : e,
    //     categoryList: this.categoryResults,
    //     type:'part'
    //   },
    // });
    // const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
    //   if (isSuccess) {
    //     const { categoryId ,name} = data.category;
    //     if(this.part && this.part.category?.name === name) {this.part.category.name = selectedName};
    //      this.categories.map( (item, index) => {
    //       if(item._id === categoryId) this.categories.splice(index,1);
    //     });
    //     this.categoryResults = [...this.categories];
    //   }
    //   onClose.unsubscribe();
    // });
  }

  initializePricings() {
    if (this.partId) {
      this.setPricing();
      this.setPartData();
    } else if (!this.isLocal) {
      this.setDefaultPricing();
    }
  }

  setPricingMatrix(pricings: any[]) {
    this.pricingMatrixResults = [...pricings];
  }

  setCategories(categories: any[]) {
    this.categoryResults = [...categories];
  }

  setSuppliers(suppliers: any[]) {
    this.suppliersResults = [...suppliers];
  }

  getQtyOtherLocationTooltip() {
    let tooltip = '';
    let otherLocationQty = 0;
    if (this.partStockDetails?.length) {
      let locData: string = '';
      this.partStockDetails.forEach((location) => {
        const warehouse = find(this.warehouses, (item: any) => {
          if (this.dataService.warehouse?.warehouseId !== item?._id && item?._id === location?.warehouseId) {
            return true;
          }
        });

        if (location?.warehouseId === warehouse?._id) {
          otherLocationQty += location?.countAvailable;
          locData =
            locData +
            `
        <div class="flex-between-center pb-1">
          <span class="font-10 font-400">${warehouse?.name || ''}</span>
          <span class="font-10 font-400">${this.calculationService.roundOff(location?.countAvailable)}</span>
        </div>`;
        }
      });
      if (locData) {
        tooltip = `
      <div class="flex-column p-1">
        <div class="border-bottom-white flex-between-center pb-1 mb-2">
          <span class="font-12 font-400">Warehouse</span>
          <span class="font-12 font-400">QTY</span>
        </div>
        ${locData}
      </div>`;
      }
    }
    otherLocationQty = this.calculationService.roundOff(otherLocationQty);
    return { otherLocationQty, tooltip };
  }

  // getQtyOtherLocationTooltip(partData: any): string {
  //   let tooltip: string = '';
  //   if (partData?.otherLocationData?.length) {
  //     partData.otherLocationData = orderBy(partData.otherLocationData, 'countAvailable', 'desc');
  //     let locData: string = '';
  //     partData?.otherLocationData.forEach((location: any) => {
  //       locData =
  //         locData +
  //         `
  //       <div class="flex-between-center pb-1">
  //         <span class="font-10 font-400">${location?.warehouseName || ''}</span>
  //         <span class="font-10 font-400">${location?.countAvailable || ''}</span>
  //       </div>`;
  //     });
  //     tooltip = `
  //     <div class="flex-column p-1">
  //       <div class="border-bottom-white flex-between-center pb-1 mb-2">
  //         <span class="font-12 font-400">Warehouse</span>
  //         <span class="font-12 font-400">QTY</span>
  //       </div>
  //       ${locData}
  //     </div>`;
  //   }
  //   return tooltip;
  // }

  handleTransferSelect(event: any) {
    this.item.transferedVia = event?.value;
    this.createTransferOrderWithItems([this.item]);
  }

  createTransferOrderWithItems(itemsList: any[]) {
    this.httpService
      .createTransferStockOrder(itemsList)
      .then((res) => {
        if (res) {
          try {
            this.helperService.openPageInNewTab(`${config.redirectUrl.transferStock}/${res._id}`);
          } catch (error) {
            this.helperService.showToaster('error', error);
          }
        }
      })
      .catch((err) => {
        this.helperService.showToaster('error', err);
      });
  }

  setLocations(locations: any[]) {
    // this.locationsResults = [...locations];
  }

  setItemDetails(part: any) {
    if (this.partId && part) {
      this.initialPrice = part?.price;
      this.part = {
        name: part.title,
        titleFR: part.titleFR,
        category: part.category,
        salesCode: part.salesCode,
        initialDefaultCost: part.cost,
        cost: part.cost,
        price: part.price,
        supplier: part.supplier,
        number: part.code,
        fixedCost: part.fixedCost,
        pricing: part.pricing,
        description: part.description,
        descriptionFR: part.descriptionFR,
        internalNotes: part.internalNotes,
        isTaxable: part.isTaxable,
        itemRef: { qboId: part.qboItemRefId },
        locationQboItemRefId: part.locationQboItemRefId || {},
        displayHoursOnOrder: part.displayHoursOnOrder,
        displayDescOnOrder: part.displayDescOnOrder,
        commissionable: part.commissionable,
        status: part.status,
        restockLevel: part.restockLevel,
        maxQuantity: part.maxQuantity,
        count: Number(part.count),
        stocked: part.stocked,
        hasCore: part.hasCore,
        coreCost: part.coreCost,
        shopDetails: part.shopDetails,
        isChangeInPriceMatrix: part.isChangeInPriceMatrix || false,
        whichPricingMatrixUsed: part.whichPricingMatrixUsed,
      };

      if (this.isNewCategoriesEnabled) {
        this.isCustomerCategory = !!part.category?.categoryName;
        this.part.category = part.category;
      }

      if (this.isInventoryEnabled) {
        this.part.hasMarkedInventory = part.hasMarkedInventory;
      }

      if (part.associatedItems && part.associatedItems.length > 0) {
        this.hazmatFeeArray = part.associatedItems.map(({ itemId }) => itemId);
      }

      if (this.stock) {
        this.part.qtyOnOrder = this.stock.countOnEstimate || 0;
        this.part.qtyAvailable = this.stock.countAvailable || 0;
        this.part.qtyOrdered = this.stock.countOrdered || 0;
        this.part.qtyOnHand = this.stock.countInHand || 0;
        this.part.partsTechDetails = this.stock.partsTechDetails;
      }

      if (!part.costType) {
        this.part.costType = part.stocked ? 'avg' : 'cost';
        this.part.cost = this.part.costType === 'avg' ? this.averageCost : this.part.costType === 'latestPo' ? this.latestPoCost : part.fixedCost ? part.fixedCost : part.cost;
      } else {
        this.part.costType = part.costType;
      }

      if (this.part?.stocked) {
        this.setStockedCostData(part.costType, part?.cost);
      }

      if (part.locations && part.locations.length) {
        this.part.location = part.locations.pop();
      } else {
        if (this.stock) this.part.location = this.stock.location;
      }

      const currentShopDetails = find(part?.shopDetails, { shopId: this.helperService.getCurrentShopId() });
      if (currentShopDetails) {
        this.part.pricing = {
          pricingId: currentShopDetails?.pricing?.pricingId,
          name: currentShopDetails?.pricing?.name,
        };
      } else {
        if (part.pricing && part.pricing.pricingId) {
          this.part.pricing = {
            pricingId: part.pricing.pricingId._id,
            name: part.pricing.pricingId.name,
          };
        }
      }

      this.defaultActiveState = part.status;
      this.initalInputStates = this.helperService.deepCopy(this.part);

      if (this.part.category && this.part.category.categoryId) {
        this.part.category = {
          ...this.part.category,
          categoryId: this.part.category.categoryId,
        };
      }

      if (this.pricings.length) {
        this.setPricing();
      }

      if (this.isSalesCodeEnabled) {
        this.defaultSalesCode = this.helperService.deepCopy(part?.salesCode);
      }
    } else {
      //this.part.commissionable = this.dataService.isCommissionParts;

      if (this.isOpenFromPO && this.poDetails?.onlineItem) {
        this.setPartsTechPartInfo(this.poDetails?.onlineItem);
        this.initialPrice = this.part?.price;
        this.part.partsTechDetails = {
          partNumber: this.poDetails?.onlineItem?.code,
        };
        if (this.isMarkAsInventoryEnabled) {
          this.part.hasMarkedInventory = true;
        }
      }
      this.part.commissionable = this.dataService.isCommissionParts;
    }

    if (this.isMultiLocationEnabled && this.isStockTransferEnabled) {
      this.partStockDetails = part?.stockDetails || [];
      if (this.warehouses?.length) {
        const { otherLocationQty, tooltip } = this.getQtyOtherLocationTooltip();
        this.part.otherLocationDataTooltip = tooltip;
        this.part.otherLocationQty = otherLocationQty;
      }
    }
    this.setItemRef();
    this.setPartData();
    this.part.totalCost = this.part.count * this.part.cost;
    this.part.totalPrice = this.part.count * this.part.price;
    this.checkShopLevelDetails();
    this.isProcessing = false;
  }

  setStockedCostData(costType: string, partCost: number) {
    if (costType) {
      if (costType === 'avg') {
        this.part.cost = this.averageCost;
      } else if (costType === 'latestPo') {
        this.part.cost = this.latestPoCost;
      } else if (costType === 'cost') {
        this.part.cost = partCost;
      }
    }
  }

  setPartsTechPartInfo(part: any) {
    this.part = {
      name: part?.title,
      category: part?.category,
      cost: part?.cost,
      price: part?.price,
      supplier: part?.supplier,
      number: part?.code,
      fixedCost: part?.fixedCost,
      pricing: part?.pricing,
      description: part?.description,
      internalNotes: part?.internalNotes,
      isTaxable: part?.isTaxable,
      itemRef: { qboId: part?.qboItemRefId },
      locationQboItemRefId: part.locationQboItemRefId || {},
      displayHoursOnOrder: part?.displayHoursOnOrder,
      displayDescOnOrder: part?.displayDescOnOrder,
      commissionable: part?.commissionable,
      status: part?.status,
      restockLevel: part?.restockLevel,
      maxQuantity: part?.maxQuantity,
      count: Number(part?.quantity),
      stocked: part?.stocked,
      hasCore: part?.hasCore,
      coreCost: part?.coreCost,
    };
  }

  setPartData() {
    if ((this.serviceItem && this.serviceItem.itemId) || (this.serviceItem && this.serviceItem.isPreFilledPartFields)) {
      if (this.serviceItem.focusSupplier) this.focus.supplier = true;

      this.part = {
        ...this.part,
        cost: this.serviceItem.hasOwnProperty('cost') ? this.serviceItem.cost : this.part.cost,
        number: this.serviceItem.code ? this.serviceItem.code : this.part.number,
        description: this.serviceItem.hasOwnProperty('description') ? this.serviceItem.description : this.part.description,
        internalNotes: this.serviceItem.hasOwnProperty('internalNotes') ? this.serviceItem?.internalNotes : this.part.internalNotes,
        isTaxable: this.serviceItem.hasOwnProperty('isTaxable') ? this.serviceItem.isTaxable : this.part.isTaxable,
        status: true,
        isChangeInPriceMatrix: this.serviceItem.isChangeInPriceMatrix || false,
        whichPricingMatrixUsed: this.serviceItem.whichPricingMatrixUsed,
      };

      if (this.serviceItem.hasOwnProperty('title')) {
        this.part.name = this.serviceItem.title;
        if (this.isPreFilledPartFields) {
          this.checkUniqueTitle();
        }
      }

      if (this.serviceItem.hasOwnProperty('titleFR')) {
        this.part.titleFR = this.serviceItem.titleFR;
      }

      if (this.isOpenFromPO || this.isOpenFromST) {
        this.part.initialDefaultCost = this.part.cost;
      }

      if (this.serviceItem.hasOwnProperty('code')) {
        this.part.number = this.serviceItem.code;
      }

      if (this.serviceItem.hasOwnProperty('category')) {
        if (this.isNewCategoriesEnabled) {
          this.part.category = {
            ...this.serviceItem.category,
          };
        } else {
          this.part.category = {
            ...this.part.category,
            ...this.serviceItem.category,
          };
        }
      }

      if (this.serviceItem.hasOwnProperty('count')) {
        this.part.count = this.serviceItem.count;
      }

      if (this.serviceItem.hasOwnProperty('displayHoursOnOrder')) {
        this.part.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('displayDescOnOrder')) {
        this.part.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('commissionable')) {
        this.part.commissionable = this.serviceItem.commissionable;
      }

      if (this.serviceItem.hasOwnProperty('pricing')) {
        const pricing = find(this.pricings, {
          _id: this.serviceItem.pricing && this.serviceItem.pricing.pricingId,
        });

        if (pricing && pricing._id) {
          this.applyMatrix(pricing);
        } else {
          this.pricing = null;
          if (this.serviceItem.pricing && this.serviceItem?.pricing?.name) {
            this.part.pricing = this.serviceItem.pricing;
          }
        }
        this.calculateMarkup(false);
      }

      if (this.serviceItem.hasOwnProperty('price')) {
        this.part.price = this.serviceItem.price;
        this.initialPrice = this.serviceItem.price;
      }

      if (this.serviceItem.hasOwnProperty('hasCore')) {
        this.part.hasCore = this.serviceItem.hasCore;
        this.defaultHasCore = this.part.hasCore;
      }

      if (this.serviceItem.hasOwnProperty('coreCost')) {
        this.part.coreCost = this.serviceItem.coreCost;
      }

      if (this.serviceItem.hasOwnProperty('supplier')) {
        this.part.supplier = {
          name: this.serviceItem.supplier && this.serviceItem.supplier.name,
        };
      }

      if (this.serviceItem.hasOwnProperty('salesCode') && this.serviceItem.salesCode?.salesCodeId) {
        this.part.salesCode = this.serviceItem.salesCode;
      }

      if (this.serviceItem.hasOwnProperty('itemSource')) {
        this.isPartsOrderingItem = ['PartsTech', 'Nexpart', 'RepairLink', 'SpeedDial'].includes(this.serviceItem.itemSource);
      }

      if (this.serviceItem.hasOwnProperty('hasMarkedInventory')) {
        this.part.hasMarkedInventory = this.serviceItem.hasMarkedInventory;
      }

      if (this.serviceItem.hasOwnProperty('restockLevel')) {
        this.part.restockLevel = this.serviceItem.restockLevel;
      }

      if (this.serviceItem.hasOwnProperty('maxQuantity')) {
        this.part.maxQuantity = this.serviceItem.maxQuantity;
      }

      if (this.serviceItem.hasOwnProperty('locations')) {
        if (this.serviceItem.locations && this.serviceItem.locations.length === 1) {
          this.part.location = this.serviceItem.locations[0];
        }
      }

      if (this.serviceItem.qboId) {
        this.part.itemRef = { qboId: this.serviceItem.qboId };
        this.setItemRef();
      }
    }

    if (this.part.number && this.isNewCategoriesEnabled && !this.part.category?._id) {
      this.getPartstechSearch(this.part.number);
    }
  }

  _checkUniqueTitle() {
    if ((!this.part.name.trim() || (this.partId && this.orderServiceId) || this.isPartsOrderingItem) && !this.isPreFilledPartFields) return;

    const query = { title: this.part.name.trim(), type: 'part', code: '' };

    if (this.helperService.trimString(this.part.number)) query.code = this.part.number.trim();

    this.httpService.isItemTitleUnique(query, this.partId).then(
      (res) => {
        if (res.duplicateItems && res.duplicateItems.length) {
          this.errors.number = 'Other matches found for this Item #';
          this.createItemNumberTooltip(res.duplicateItems);
        } else {
          this.errors.number = '';
        }
        if (!res.data) {
          const errorMessage = 'Title must be unique (Title = Part name + Part number)';
          this.errors.name = errorMessage;
          this.helperService.showToaster('error', errorMessage);
          this.isTitleUnique = false;
        } else {
          this.errors.name = '';
          this.isTitleUnique = true;
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  _checkUniqueCategory() {
    this.httpService.isCategoryUnique({ name: this.categoryName.trim(), type: 'item' }, this.categorId).then(
      (res) => {
        if (!res) {
          this.isShowError = true;
        } else {
          this.isShowError = false;
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  applyMatrix(pricing) {
    if (this.isAttributeBasedPricingEnable) {
      // check if there any category link with item if so check for category overRide other wise apply default
      this.checkForOverrideCategory(pricing);
    } else {
      this.pricing = pricing;
    }
  }
  checkForOverrideCategory(pricing) {
    if (pricing._id) {
      const categoryId = this.part.category && this.part.category._id;
      if (categoryId) {
        const overrideExist = pricing?.category?.find((c) => {
          return c._id === categoryId;
        });
        if (overrideExist) {
          this.getUpdatedMatrixDetails(pricing, overrideExist.matrix);
        } else {
          this.getUpdatedMatrixDetails(pricing, pricing.defaultMatrix);
        }
      } else {
        this.getUpdatedMatrixDetails(pricing, pricing.defaultMatrix);
      }
    } else {
      this.pricing = this.noMatrix[0];
    }
  }
  handleChangeCategory(name: string, value) {
    this.categoryName = value;
    this.checkUniqueCategory();
  }

  getUpdatedMatrixDetails(rule, selectMatrix) {
    let matrixInfo = this.helperService.deepCopy(
      this.pricingMatrixList.find((m) => {
        return m._id === selectMatrix.id;
      }),
    );

    this.pricing = matrixInfo;
    this.pricing._id = rule._id;
    this.pricing.matrixName = matrixInfo.name;
    this.pricing.name = rule.name;
  }
  createItemNumberTooltip(items) {
    this.duplicateItemNumberTooltip = `
    <div class="tooltip-seondary mb-2">
      <div class="tooltip-secondary-row font-11 font-black">
          The following item(s) are already associated with this item number:
      </div>
      <ul class='m-0 pl-3'>
    `;
    items.forEach(({ title, code }) => {
      this.duplicateItemNumberTooltip += `
        <li class="font-11 font-black">${title}-${code}</li>
      `;
    });

    this.duplicateItemNumberTooltip += '</ul></div>';
  }

  /** Getting values from inputs */
  handleChange(name: string, value: any) {
    this.part[name] = value;

    if (['price', 'description', 'descriptionFR', 'isTaxable', 'hasCore', 'coreCost', 'internalNotes'].includes(name)) {
      this.updatedInputStates[name] = this.initalInputStates[name] != value;
    }

    if (name === 'name' || name === 'number') {
      this.checkUniqueTitle();
    }
    if (this.companyLocalization) {
      if (name === 'titleFR' || name === 'number') {
        this.checkUniqueTitle();
      }
    }
    if (name === 'price') {
      if (this.isPriceCalculated()) {
        this.part.isPriceManuallyAdded = false;
      } else {
        if (this.isAttributeBasedPricingEnable) {
          this.part.pricing = this.noMatrix[0];
          this.pricing = this.noMatrix[0];
        } else {
          this.part.pricing = {};
          this.pricing = {};
        }
        this.part.isPriceManuallyAdded = true;
      }
    }

    if (name === 'number' && this.isNewCategoriesEnabled && value === '' && !this.partId) {
      this.partstechResults = [];
      this.part.name = '';
      this.part.category = {};
    } else {
      if (name === 'number' && this.isNewCategoriesEnabled) {
        if (name === 'number' && this.part.number) {
          this.getPartstechSearch(value);
        }
      }
    }

    if (name === 'costType') {
      this.part[name] = value?.value;
      if (value?.value === 'avg') {
        this.part.cost = this.averageCost;
      } else if (value?.value === 'latestPo') {
        this.part.cost = this.latestPoCost;
      } else {
        this.part.cost = this.part.initialDefaultCost;
      }
      this.calculateMarkup();
      this.blurInput('count');
    }
  }

  /** Set default pricings for update view */
  setDefaultPricing() {
    for (let i = 0; i < this.pricings.length; i++) {
      if (this.pricings[i].default) {
        this.pricing = this.pricings[i];
        this.handleDropdownSelect(this.pricing);
        break;
      }
    }
  }

  /** Set pricing data */
  setPricing() {
    if (this.part.name) {
      // use the shop details pricing matrix if not found then use the root level pricing
      let matrixInfo = this.helperService.deepCopy(this.pricings);
      for (let i = 0; i < matrixInfo.length; i++) {
        if (matrixInfo[i]._id === (this.part.pricing && this.part.pricing.pricingId)) {
          this.applyMatrix(matrixInfo[i]);
          break;
        }
      }

      if (!this.pricing) {
        if (this.isAttributeBasedPricingEnable) {
          this.part.pricing = this.noMatrix[0];
        } else {
          this.part.pricing = {};
        }
      }
    }
    this.calculateMarkup();
  }

  checkShopLevelDetails() {
    const currentShopItemDetails = this.part?.shopDetails?.find((s) => s.shopId === this.helperService.getCurrentShopId());
    if (currentShopItemDetails) {
      this.part.price = currentShopItemDetails.price;
      this.part.totalPrice = this.part.count * this.part.price;
      this.part.pricing = currentShopItemDetails.pricing;
      this.pricing = currentShopItemDetails.pricing;
    }
  }
  /** Set Item Ref */
  setItemRef() {
    if (this.part && this.part.itemRef && this.part.itemRef.qboId && this.qboItemRefs.length) {
      this.part.itemRef = find(this.qboItemRefs, {
        qboId: this.part.itemRef.qboId,
      });
    }

    // if its an multiLocation tenant check that location level ref is saved then override the ref
    if (this.isMultiLocationEnabled) {
      if (this.part && this.part.locationQboItemRefId && this.part.locationQboItemRefId[this.currentShopId] && this.qboItemRefs.length) {
        const refId = this.part.locationQboItemRefId[this.currentShopId];
        this.part.itemRef = find(this.qboItemRefs, {
          qboId: refId,
        });
      }
    }
  }

  onSearchItem(name: string, query: string) {
    if (name === 'markup') {
      this.pricingMatrixResults = this.pricings.filter(({ name }) => name && new RegExp(`${query}`, 'gi').test(name));
    } else if (name === 'category') {
      this.categoriesSuggestionsResults = this.categoriesSuggestions.filter(({ categoryName }) => categoryName && new RegExp(`${query}`, 'gi').test(categoryName));
    } else if (name === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.subCategoriesSuggestions.filter(({ subCategoryName }) => subCategoryName && new RegExp(`${query}`, 'gi').test(subCategoryName));
    } else if (name === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.subSubCategoriesSuggestions.filter(({ subSubCategoryName }) => subSubCategoryName && new RegExp(`${query}`, 'gi').test(subSubCategoryName));
    } else {
      this.httpService.getQBOItemRefs(query).then(
        (data: any) => {
          if (data.items) {
            this.qboItemRefs = data.items.filter(({ type }) => type === 'part');
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }
  }

  onUpdateItem({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type: this.categoryType ? this.categoryType : type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i]._id === _id) {
            this.categories[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.categoryResults.length; i++) {
          if (this.categoryResults[i]._id === _id) {
            this.categoryResults[i].name = name;
            break;
          }
        }

        if (this.part.category && this.part.category._id === _id) {
          this.part.category.name = name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onUpdateSupplier(data: any) {
    this.httpService.updateSupplier(data).then(
      (res: any) => {
        for (let i = 0; i < this.suppliers.length; i++) {
          if (this.suppliers[i]._id === res._id) {
            this.suppliers[i].name = data.name;
            break;
          }
        }

        for (let i = 0; i < this.suppliersResults.length; i++) {
          if (this.suppliersResults[i]._id === res._id) {
            this.suppliersResults[i].name = data.name;
            break;
          }
        }

        if (this.part.supplier && this.part.supplier._id === res._id) {
          this.part.supplier.name = data.name;
        }
        this.dataService.sendData(
          this.dataService.typePassData('supplier-update', {
            ...data,
            suppliersId: data._id,
          }),
        );
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleClear(type: string = '') {
    if (type === 'location') {
      this.locationsResults = this.helperService.deepCopy(this.locations);
    } else if (type === 'markup') {
      this.pricingMatrixResults = this.helperService.deepCopy(this.pricings);
    } else if (type === 'category') {
      this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
    } else if (type === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
    } else if (type === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestionsResults);
    } else {
      this.qboItemRefs = this.helperService.deepCopy(this.defaultQboItems);
    }
  }

  /**
   * Create category
   *
   * @param data name and type of the tag
   */
  createCategory(data: any) {
    this.httpService.createTag(data).then(
      (category: any) => {
        if (category) {
          this.helperService.showToaster('success', messages.categoryCreated);
          this.categories.push(category);
          this.part.category = category;
          this.categoryResults = [...this.categories];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  /**
   * Create Supplier
   *
   * @param data name and type of the supplier
   */
  createSupplier(data: any) {
    this.httpService.createSupplier(data).then(
      (supplier: any) => {
        if (supplier) {
          this.helperService.showToaster('success', messages.supplierCreated);
          this.suppliers.push(supplier);
          this.part.supplier = supplier;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err.messages);
      },
    );
  }

  getItemTitle() {
    return [this.part.name || '', this.part.number || ''].filter((str) => str).join(' - ');
  }

  /** Focus on input fields */
  focusInput(type: string) {
    if (type === 'supplier') {
      this.scrollToBottom();
    }
    this.focus[type] = true;

    if (type === 'subCategory' && !this.subCategoriesSuggestionsResults?.length) {
      if (this.part.category?.categoryId) this.getSubCategories(this.part.category);
    }

    if (type === 'subSubCategory' && !this.subSubCategoriesSuggestionsResults?.length) {
      if (this.part.category?.categoryId && this.part.category?.subCategoryId) this.getSubSubCategories(this.part.category, this.part.category);
    }
  }

  /** Calculating markup */
  calculateMarkup(setPrice = true) {
    if (!this.part.cost || !this.pricing) {
      return;
    }

    let markup = 0;
    const pricingItems = this.pricing.defaultMatrix?.items ? this.pricing.defaultMatrix?.items : this.pricing.items;
    const itemsLength = (pricingItems && pricingItems.length) || 0;

    if (itemsLength) {
      for (let i = 0; i < itemsLength; i++) {
        const item = pricingItems[i];
        if (this.part.cost >= item.min && this.part.cost <= item.max) {
          markup = item.markup;
          break;
        }
      }
    }
    const price: any = this.calculationService.calculateMarkUpPrice(this.part.cost, markup);

    if (setPrice && this.part?.pricing?.name !== 'No pricing rules') {
      this.part.price = this.calculationService.roundOff(price);
    }
    this.whichPricingMatrixUsed = `${this.pricing?.name}:${this.pricing?.matrixName}:${markup}`;
    this.calculatedAmount = this.calculationService.roundOff(price);
    this.errors.price = '';
    this.part.totalPrice = this.calculationService.roundOff(Number(this.part?.count) * Number(this.part?.price));
  }

  /** Blur input fields */
  blurInput(type?: string, value?) {
    this.errors[type] = '';

    if (['name', 'number'].includes(type) && this.part.name) {
      this.checkUniqueTitle();
    }
    if (this.companyLocalization) {
      if (['titleFR', 'number'].includes(type) && this.part.titleFR) {
        this.checkUniqueTitle();
      }
    }

    if (['cost', 'price', 'count'].includes(type)) {
      this.part[type] = this.calculationService.roundOff(this.part[type]);
      this.part.totalPrice = this.calculationService.roundOff(Number(this.part.count) * Number(this.part.price));
      this.part.totalCost = this.calculationService.roundOff(Number(this.part.count) * Number(this.part.cost));
    }

    if (type === 'count') {
      this.part.totalPrice = this.calculationService.roundOff(Number(this.part.count) * Number(this.part.price));
      this.part.totalCost = this.calculationService.roundOff(Number(this.part.count) * Number(this.part.cost));
    }

    if (type === 'cost' && this.pricing?.name !== 'No pricing rules') {
      this.updatedInputStates.price = this.initalInputStates.price != value;
      this.focus.price = true;
      setTimeout(() => {
        this.calculateMarkup();
      }, 10);
    }

    if (type === 'number' && this.isNewCategoriesEnabled) {
      if (type === 'number' && this.part.number !== this.oldPartNumber) {
        this.oldPartNumber = this.part.number;
        this.getPartstechSearch(this.part.number);
      }
    }

    if (['cost', 'coreCost'].includes(type)) {
      this.errors.coreCost = '';

      // if (Number(this.part.coreCost) > Number(this.part.cost)) {
      //   this.errors.coreCost = 'Core cost cannot be greater than item cost';
      // }
    }

    this.focus[type] = false;
  }

  /** Close dialog */
  closeDialog(isSuccess: boolean = false, data: any = {}) {
    this.handleClose.emit({
      data,
      isSuccess,
    });
  }

  /** Open dropdown for the autocomplete */
  showSuggestions(type?: string) {
    this.errors.supplier = '';
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    } else {
      this.suppliersResults = [...this.suppliers];
    }

    if (type === 'supplier') {
      this.scrollToBottom();
    }

    this.isShowError = false;
  }

  /**
   * Search categories and supplier locally
   *
   * @param query query
   * @param type type of tha autocomplete
   */
  searchSuggestion(query: string, type?: string) {
    this.categoryResults = [];
    this.suppliersResults = [];
    query = this.helperService.trimString(query);
    if (type === 'tags') {
      this.categoryResults = this.categories.filter(({ name }) => {
        if (name && new RegExp(`${query}`, 'gi').test(name)) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      this.suppliersResults = this.suppliers.filter(({ name }) => {
        if (name && new RegExp(`${query}`, 'gi').test(name)) {
          return true;
        } else {
          return false;
        }
      });
      this.suppliersResults = [...this.suppliersResults];
    }
  }

  graphdata(itemId, type) {
    this.httpService.getSalesTrendHistory(itemId, type).then((res: any) => {
      this.dataService.stockItemdata.next(res.trend);
    });
  }
  onClearSuggestion(type: string = '') {
    if (type === 'supplier') {
      this.suppliersResults = [...this.suppliers];
    } else {
      this.categoryResults = [...this.categories];
    }
  }

  /**Hanlde markup select */
  handleDropdownSelect(event: any) {
    this.part.pricing = event;
    this.applyMatrix(event);
    this.calculateMarkup();
    if (!this.isPricingManagementEnable || !this.isPricingMatricesManagement || this.isPricingMatricesManagement === undefined) {
      this.isChangeInPriceMatrix = true;
      this.updateGenericItem = false;
    }
  }

  /** Getting data from dropdown */
  handleSelect(type: string, value: any) {
    this.part[type] = value;
  }

  handleMultiplePartCheck(value: boolean) {
    this.isCreateMultiple = value;
  }

  handleConfirmLocationUpdate(iLocation: any) {
    const { location } = this.part;

    if (!location || (location && !location.locationId)) {
      this.handleSelect('location', iLocation);
    } else {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: `Update location for ${this.part.name}`,
          message: `Changing the location for ${this.part.name} will also update its location on all the POs that have not been received so far. Do you want to continue?`,
          button: {
            success: { title: 'Confirm' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          this.handleSelect('location', iLocation);
        }

        onClose.unsubscribe();
      });
    }
  }

  /** Call the create category endpoint with all the data */
  saveCategory({ name }) {
    this.createCategory({
      name,
      type: this.categoryType ? this.categoryType : config.tags.part,
      color: '',
    });
  }

  /** Call the create supplier endpoint with all the data */
  saveSupplier({ name }) {
    this.createSupplier({
      name,
    });
  }

  /** Select category or supplier */
  onAutoCompleteSelect(event: any, type?: string) {
    if (type === 'tags') {
      this.part.category = event;
      this.checkCategoryOverAndApplyMatrix();
    } else {
      this.part.supplier = event;
    }
  }

  /** Validating Parts */
  validatePart() {
    let isPartDataValid = true;
    if (this.companyLocalization && this.currentLang === 'fr') {
      if (!this.part.titleFR?.trim()) {
        this.errors.titleFR = '* Part name in French is required';
        isPartDataValid = false;
        this.helperService.showToaster('error', 'Part name in French is required');
      }
    } else {
      if (!this.part.name?.trim()) {
        this.errors.name = '* Part name is required';
        isPartDataValid = false;
        this.helperService.showToaster('error', 'Part name is required');
      }
    }

    if (!this.isTitleUnique) {
      this.errors.name = 'Part name must be unique';
      isPartDataValid = false;
      this.helperService.showToaster('error', 'Part name must be unique');
    }

    if (this.part.stocked && Number(this.part.maxQuantity) < Number(this.part.restockLevel)) {
      // check if item is inventory
      this.errors.restockLevel = 'Minimum quantity level can not be greater than the maximum quantity level';
      isPartDataValid = false;
    }

    if ((this.part.hasMarkedInventory || this.part.stocked) && !this.part.location) {
      // check if item is inventory
      this.errors.location = 'Location is required';
      this.helperService.showToaster('error', 'Location is required');
      isPartDataValid = false;
    }

    if (this.openFrom === 'inventoryAdd' && (!this.part.location || !this.part.location.locationId)) {
      // check if item is inventory
      this.errors.location = 'Location is required';
      this.helperService.showToaster('error', 'Location is required');
      isPartDataValid = false;
    }

    // changed validation condition
    if (this.part.cost === '') {
      this.errors.cost = '* Cost required';
      isPartDataValid = false;
    }
    if (this.part.price === '') {
      this.errors.price = '* Price required';
      isPartDataValid = false;
    }

    if (this.part.hasCore) {
      if (this.part.coreCost === '') {
        this.errors.coreCost = '* Core cost required';
        isPartDataValid = false;
      }

      // if (Number(this.part.coreCost) > Number(this.part.cost)) {
      //   this.errors.coreCost = 'Core cost cannot be greater than item cost';
      //   isPartDataValid = false;
      // }
    }

    return isPartDataValid;
  }

  resetData() {
    this.part = {
      _id: '',
      name: '',
      category: { name: '' },
      cost: '',
      price: '',
      supplier: { name: '' },
      number: '',
      pricing: {},
      description: '',
      internalNotes: '',
      isTaxable: this.defaultTaxable,
      displayHoursOnOrder: true,
      displayDescOnOrder: true,
      status: true,
      itemRef: {},
    };
    this.focus.name = true;
    this.errors = {};
    this.partId = null;
    this.calculatedAmount = '';
    this.hazmatFeeArray = [{}];
    this.itemResults = [[]];
    this.setDefaultPricing();
  }

  logPXGaingSightCustomEvent(res: any) {
    if (res?.salesCode?.salesCodeId && res?.salesCode?.salesCodeId !== this.defaultSalesCode?.salesCodeId) {
      const logInfo = {
        itemName: res?.title || res?.name,
        salesCodeName: res?.salesCode?.title,
        salesCode: res?.salesCode?.shortName,
        category: res?.category?.name,
        subCategory: res?.category?.subCategoryName,
        itemType: res?.type,
        assignmentType: this.isAutoAssign ? 'Auto' : 'User has assigned sales code directly from the Catalog/RO',
      };
      this.helperService.logPXGaingSightEvent('Sales code assigned to an item', logInfo);
    }
  }

  /** Creating parts */
  createPart(part: any, unassignedCat?: any) {
    delete part._id;
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    const item = this.helperService.deepCopy(part);
    if (this.isOpenFromPO || this.orderServiceId) {
      if (this.isSalesCodeEnabled && !this.canEditClassifications) {
        part.salesCode = this.defaultSalesCode;
      }
    }

    this.httpService
      .createItem({
        ...part,
        pricing: {
          pricingId: this.pricing && this.pricing._id,
          name: this.pricing && this.pricing.name,
        },
        supplier: {
          supplierId: this.part.supplier && this.part.supplier._id,
          name: this.part.supplier && this.part.supplier.name,
        },
      })
      .then(
        (res: any) => {
          this.isProcessing = false;
          this.helperService.showToaster('success', messages.partCreation);
          this.dataService.sendData(this.dataService.typePassData('part-list', {}));

          if (this.isOpenFromPO || this.orderServiceId) {
            if (this.isSalesCodeEnabled && !this.canEditClassifications) {
              res.salesCode = item?.salesCode;
            }
          }

          if (this.isSalesCodeEnabled) {
            this.logPXGaingSightCustomEvent(res);
          }

          if (this.isOpenFromPO) {
            this.dataService.sendData(
              this.dataService.typePassData('po-service-item', {
                ...res,
                actionType: 'create',
                poDetails: this.poDetails,
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
              }),
            );
          } else if (this.orderServiceId) {
            this.dataService.sendData(
              this.dataService.typePassData('ro-service-item', {
                ...res,
                actionType: 'create',
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
              }),
            );
          } else if (this.openFrom == 'cannedService') {
            this.dataService.sendData(this.dataService.typePassData('canned-service-item', { ...res, actionType: 'create' }));
          } else if (this.openFrom == 'inventoryAdd') {
            if (this.part.location && this.part.location.locationId) {
              res.locations = [{ ...this.part.location }];
            }

            this.dataService.sendData(this.dataService.typePassData('item-inventory-add', { ...res }));
          } else {
            this.dataService.sendData(this.dataService.typePassData('catalogue-item', { ...res, actionType: 'create' }));
          }

          if (!this.isCreateMultiple) {
            this.dynamicDialogRef.close();
          } else {
            this.resetData();
          }
        },
        (err) => {
          this.isProcessing = false;
          this.helperService.showToaster('error', err);
        },
      );
  }

  /** Updating parts */
  updatePart(part: any) {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;

    if (this.isOpenFromST) {
      part.isForceStockUpdate = true;
      delete part?.cost;
    }

    if (this.openFrom === 'inventoryAdd') {
      this.isProcessing = false;
      this.dynamicDialogRef.close();

      if (this.partId) {
        part._id = this.partId;
      }

      this.dataService.sendData(this.dataService.typePassData('item-inventory-add', { ...part }));
    } else if ((this.orderServiceId || this.isOpenFromPO) && !this.updateGenericItem && !this.isOpenFromST && !this.isOpenFromMO) {
      this.isProcessing = false;
      this.dynamicDialogRef.close();

      if (this.partId) {
        part._id = this.partId;
      }

      if (this.isSalesCodeEnabled && part.salesCode.salesCodeId && this.serviceItem?.salesCode?.salesCodeId !== part.salesCode.salesCodeId) {
        this.logPXGaingSightCustomEvent(part);
      }

      this.dataService.sendData(
        this.dataService.typePassData('ro-service-item', {
          ...part,
          actionType: 'update',
          isLocal: true,
          serviceId: this.orderServiceId,
          index: this.orderServiceItemIndex,
          isChangeInPriceMatrix: this.isChangeInPriceMatrix,
          whichPricingMatrixUsed: this.whichPricingMatrixUsed,
          isPriceManuallyAdded: this.part.isPriceManuallyAdded,
        }),
      );
      this.dataService.sendData(
        this.dataService.typePassData('po-service-item', {
          ...part,
          actionType: 'update',
          serviceId: this.orderServiceId,
          index: this.orderServiceItemIndex,
        }),
      );

      // if(this.isOpenFromST) {
      //   this.dataService.sendData(
      //     this.dataService.typePassData('st-card-group-item', {
      //         ...part,
      //       actionType: 'update',
      //       serviceId: this.orderServiceId,
      //       index: this.orderServiceItemIndex,
      //       cardGroupIndex: this.cardGroupIndex,
      //     })
      //   );
      // }
    } else {
      const item = this.helperService.deepCopy(part);
      if (this.isSalesCodeEnabled && !this.canEditClassifications && (this.orderServiceId || this.isOpenFromPO)) {
        part.salesCode = this.defaultSalesCode;
      }
      if (this.isOpenFromMO) {
        part.isUpdateLocationOnly = true;
        part.orderId = this.orderId;
      }
      this.httpService
        .updateItem({
          ...part,
        })
        .then(
          (res: any) => {
            this.isProcessing = false;
            this.helperService.showToaster('success', messages.partUpdate);
            this.dynamicDialogRef.close();
            this.dataService.sendData(this.dataService.typePassData('part-list', {}));
            if (res?.cost) {
              res.cost = this.formatService.setDynamicCostAndPrice(res, 'cost');
            }

            if (this.isSalesCodeEnabled && !this.canEditClassifications && (this.orderServiceId || this.isOpenFromPO)) {
              res.salesCode = item?.salesCode;
            }

            if (this.isSalesCodeEnabled) {
              this.logPXGaingSightCustomEvent(res);
            }
            if (this.isOpenFromMO) this.dataService.sendData(this.dataService.typePassData('manual-order-update', {}));

            if (this.isOpenFromST) {
              const data: any = {
                ...res,
                actionType: 'update',
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
                cardGroupIndex: this.cardGroupIndex,
              };
              data.cost = this.part.cost;
              this.dataService.sendData(this.dataService.typePassData('st-card-group-item', data));
            } else if (this.isOpenFromPO) {
              this.dataService.sendData(
                this.dataService.typePassData('po-service-item', {
                  ...res,
                  cost: this.part.cost,
                  actionType: 'update',
                  serviceId: this.orderServiceId,
                  index: this.orderServiceItemIndex,
                }),
              );
            } else if (this.orderServiceId) {
              this.dataService.sendData(
                this.dataService.typePassData('ro-service-item', {
                  ...res,
                  actionType: 'update',
                  serviceId: this.orderServiceId,
                  index: this.orderServiceItemIndex,
                }),
              );
            }

            // open update canned service dialog
            let isUpdated = false;
            if (this.part.price && this.initalInputStates.price != this.part.price) {
              isUpdated = true;
              this.updatedInputStates.price = this.part.price;
            }

            if (this.initalInputStates.hasCore != this.part.hasCore) {
              isUpdated = true;
              this.updatedInputStates.hasCore = this.part.hasCore;
            }

            if (this.initalInputStates.coreCost != this.part.coreCost) {
              isUpdated = true;
              this.updatedInputStates.coreCost = this.part.coreCost;
            }

            if (this.part.description && this.initalInputStates.description != this.part.description) {
              isUpdated = true;
              this.updatedInputStates.description = this.part.description;
            }

            if (this.part.internalNotes && this.initalInputStates.internalNotes != this.part.internalNotes) {
              isUpdated = true;
              this.updatedInputStates.internalNotes = this.part.internalNotes;
            }

            if (this.part.isTaxable && this.initalInputStates.isTaxable != this.part.isTaxable) {
              isUpdated = true;
              this.updatedInputStates.isTaxable = this.part.isTaxable;
            }

            if (this.part.cost && this.initalInputStates.cost != this.part.cost) {
              isUpdated = true;
              this.updatedInputStates.cost = this.part.cost;
            }

            if (this.part.cost && this.initalInputStates.count != this.part.count) {
              isUpdated = true;
              this.updatedInputStates.count = this.part.count;
            }

            if (Object.values(this.updatedInputStates).includes(true) || isUpdated) {
              this.openUpdateCannedServicesDialog(res);
            }
          },
          (err) => {
            this.isProcessing = false;

            if (err === 'exists_in_order') {
              const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
                width: '30%',
                styleClass: 'small-heading-dialog',
                showHeader: false,
                data: {
                  styleClassHeading: 'font-14',
                  title: 'Confirmation',
                  message: 'This item is already used on an RO, Do you want to create this as a new inventory item',
                  button: {
                    success: { title: 'Create new item' },
                    cancel: { title: 'Cancel' },
                  },
                },
              });

              const onClose = ref.onClose.subscribe((close: any) => {
                if (close?.isSuccess) {
                  // Creating new part
                  const nPart = this.helperService.deepCopy(this.makePartPayload(true));
                  nPart.byPassUniqueTitleCheck = true;
                  delete nPart._id;
                  this.isProcessing = false;
                  this.createPart(nPart);

                  // Updating old part
                  this.part.status = false;
                  this.part.name += ` - Non-inventory`;
                  this.part.hasMarkedInventory = false;
                  this.isLoading = true;
                  this.isProcessing = false;
                  this.onSubmit();
                } else {
                  this.part.isForceStockUpdate = true;
                  this.onSubmit();
                }

                onClose.unsubscribe();
              });
            } else {
              this.helperService.showToaster('error', err);
            }
          },
        );
    }
  }

  async updateCannedService(data) {
    const cannedServices = await this.httpService.getCannedServicesByItem(this.partId);

    if (cannedServices.length === 0) {
      return;
    }
    const payload = <any>{
      services: cannedServices.map((c: any) => {
        return {
          _id: c._id,
          itemType: c.itemType,
        };
      }),
      itemId: this.partId,
      isPassThroughTax: data.isPassThroughTax,
    };
    // payload.cost = data.cost;
    // payload.price = data.price;
    payload.cost = this.formatService.setDynamicCostAndPrice(data, data.cost);
    payload.price = this.formatService.setDynamicCostAndPrice(data, data.price);
    await this.httpService.updateCannedServicesByItem(payload);
  }

  getLocations(limit = 200, offset = this.tableConfig.offset, sortField: any = this.tableConfig.sortField, sortOrder = this.tableConfig.sortOrder, activeStatus = this.activeStatus, search = '') {
    const conf = {
      limit,
      offset,
      sortField,
      sortOrder,
      search,
      activeStatus,
    };

    this.httpService.getLocations({ ...conf, structure: 'flat' }).then(
      (location: any) => {
        this.locationsResults = location.records.map(({ _id, title, warehouseId }) => ({
          locationId: _id,
          name: title,
          warehouseId: warehouseId,
        }));
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  makePartPayload(isOpenCreate = false) {
    const hazamFeeList = [];
    const unassignedCat = find(this.categories, { name: 'Unassigned' });

    if (unassignedCat?._id) {
      unassignedCat.categoryId = unassignedCat._id;
      unassignedCat.name = unassignedCat.name;
    }

    this.hazmatFeeArray.map((itm) => {
      if (itm && itm._id) {
        hazamFeeList.push({ itemId: itm._id });
      }
    });

    const part: any = {
      _id: this.partId,
      title: this.part.name,
      titleFR: this.part.titleFR,
      code: this.part.number,
      type: 'part',
      markUp: 0,
      isTaxable: this.part.isTaxable,
      //we only update cost when the cost type is cost - ALP-15794
      //cost: this.part.cost,
      price: this.part.price,
      notes: this.part.description || '',
      description: this.part.description || '',
      descriptionFR: this.part.descriptionFR || '',
      internalNotes: this.part.internalNotes || '',
      qboItemRefId: (this.part.itemRef && this.part.itemRef.qboId) || '',
      locationQboItemRefId: this.part.locationQboItemRefId || {},
      displayHoursOnOrder: this.part.displayHoursOnOrder,
      displayDescOnOrder: this.part.displayDescOnOrder,
      commissionable: this.part.commissionable,
      status: this.part.status,
      costType: this.part.costType,
      category: unassignedCat,
      supplier: this.part.supplier,
      pricing: this.part.pricing,
      stocked: this.part.stocked,
      shopDetails: this.part.shopDetails,
      associatedItems: hazamFeeList,
      hasCore: this.part.hasCore,
      coreCost: this.part.coreCost,
      hasMarkedInventory: this.part.hasMarkedInventory,
      isForceStockUpdate: this.part.isForceStockUpdate || false,
      isPriceManuallyAdded: this.part.isPriceManuallyAdded || false,
      isChangeInPriceMatrix: this.isChangeInPriceMatrix,
      whichPricingMatrixUsed: this.whichPricingMatrixUsed,
    };

    if (!this.part.hasCore) {
      part.coreCost = 0;
    }

    if (this.part.costType !== 'avg' && this.part.costType !== 'latestPo') {
      part.fixedCost = part.cost;
      //we only update cost when the cost type is cost - ALP-15794
      part.cost = this.part.cost;
    }

    if (this.isOpenFromPO || this.isOpenFromRO) {
      part.cost = this.part.cost;
    }

    if (this.isNewCategoriesEnabled && this.isSalesCodeEnabled) {
      if (this.part.salesCode && this.part.salesCode?.salesCodeId) part.salesCode = this.part.salesCode;
      else part.salesCode = {};

      part.isAutoAssign = this.isAutoAssign;
    }

    if (this.part.count >= 0) {
      part.count = this.part.count;
    }

    if (this.part.location && this.part.location.locationId) {
      part.locations = [this.part.location];
    }

    if (this.part.itemRef && this.part.itemRef.qboId) {
      part.qboId = this.part.itemRef && this.part.itemRef.qboId;
      if (this.isMultiLocationEnabled) {
        part.locationQboItemRefId[this.currentShopId] = part.qboId;
      }
    }

    if (this.part.category && (this.part.category._id || this.part.category.categoryId)) {
      part.category = {
        categoryId: this.part.category._id || this.part.category.categoryId,
        name: this.part.category.name,
      };
    }

    if (this.part.category && this.isNewCategoriesEnabled) {
      part.category = {
        ...this.part.category,
        name: this.part.category.name,
        categoryId: this.part.category.categoryId || '',
      };
    }

    if (this.part.supplier) {
      part.supplier = {
        supplierId: this.part.supplier._id,
        name: this.part.supplier.name,
      };
    }

    if (this.pricing && this.pricing._id) {
      part.pricing = {
        pricingId: this.pricing && this.pricing._id,
        name: this.pricing && this.pricing.name,
      };
    }
    if (this.part.hasMarkedInventory || this.part.stocked) {
      part.restockLevel = this.part.restockLevel;
      part.maxQuantity = this.part.maxQuantity;
    }

    // check if location level details add are not if not add to existing array

    this.checkShopLevelDetailsAdded(part, isOpenCreate);
    return part;
  }

  checkShopLevelDetailsAdded(part, isOpenCreate) {
    if (!part.shopDetails || part.shopDetails.length === 0) {
      part.shopDetails = [
        {
          shopId: this.helperService.getCurrentShopId(),
          pricing: {
            pricingId: this.pricing && this.pricing._id,
            name: this.pricing && this.pricing.name,
          },
          price: this.part.price,
          stocked: this.part.stocked,
          maxQuantity: this.part.maxQuantity || 0,
          restockLevel: this.part.restockLevel || 0,
          whichPricingMatrixUsed: this.whichPricingMatrixUsed || '',
        },
      ];
    } else {
      const shopLevelDetails = findIndex(part.shopDetails, {
        shopId: this.helperService.getCurrentShopId(),
      });
      if (shopLevelDetails === -1) {
        part.shopDetails.push({
          shopId: this.helperService.getCurrentShopId(),
          pricing: {
            pricingId: this.pricing && this.pricing._id,
            name: this.pricing && this.pricing.name,
          },
          price: this.part.price,
          stocked: this.part.stocked,
          maxQuantity: this.part.maxQuantity || 0,
          restockLevel: this.part.restockLevel || 0,
          whichPricingMatrixUsed: this.whichPricingMatrixUsed || '',
        });
      } else {
        part.shopDetails[shopLevelDetails].pricing = {
          pricingId: this.pricing && this.pricing._id,
          name: this.pricing && this.pricing.name,
        };
        part.shopDetails[shopLevelDetails].price = this.part.price;
        part.shopDetails[shopLevelDetails].stocked = this.part.stocked;
        part.shopDetails[shopLevelDetails].maxQuantity = this.part.maxQuantity;
        part.shopDetails[shopLevelDetails].restockLevel = this.part.restockLevel;
        part.shopDetails[shopLevelDetails].whichPricingMatrixUsed = this.whichPricingMatrixUsed || '';
      }
    }

    if (!isOpenCreate && !this.isOpenFromRO && !this.isOpenFromPO && !this.isOpenFromST) {
      delete part.pricing;
      delete part.price;
      delete part.whichPricingMatrixUsed;
    }
    return part;
  }
  /** Submitting form data */
  onSubmit() {
    this.errors = {};

    if (this.validatePart()) {
      const unassignedCat = find(this.categories, { name: 'Unassigned' });

      if (unassignedCat?._id) {
        unassignedCat.categoryId = unassignedCat._id;
        unassignedCat.name = unassignedCat.name;
      }

      if (this.partId || (this.serviceItem && this.serviceItem.itemId)) {
        this.updatePart(this.makePartPayload(false));
      } else {
        this.createPart(this.makePartPayload(true), unassignedCat);
      }
    }
  }

  onSearchLocation(query: string = '') {
    this.locationsResults = this.locations.filter(({ name }) => new RegExp(query, 'i').test(name));
  }

  search(query: string) {
    this.isLoading = true;
    if (query) {
      const conf = {
        limit: 200,
        offset: 0,
        sortField: 'title',
        sortOrder: 1,
        search: query.trim(),
        activeStatus: this.activeStatus || '',
      };

      this.httpService.getLocations({ ...conf, structure: 'flat' }).then(
        (location: any) => {
          this.locationsResults = location.records.map(({ _id, title, warehouseId }) => ({
            locationId: _id,
            name: title,
            warehouseId: warehouseId,
          }));
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.helperService.showToaster('error', error);
        },
      );
    } else {
      this.getLocations();
    }
  }

  /**
   * Get canned services for the provided item
   */
  async openUpdateCannedServicesDialog(data) {
    try {
      const cannedServices = await this.httpService.getCannedServicesByItem(data._id);

      if (cannedServices.length === 0) return;
      data.cost = this.formatService.setDynamicCostAndPrice(data, 'cost');
      data.price = this.formatService.setDynamicCostAndPrice(data, 'price');
      // open update canned service dialog
      this.dialogService.open(UpdateCannedServiceDialogComponent, {
        width: '50%',
        styleClass: 'add-dialog add-part update-canned overflow-initial',
        showHeader: false,
        data: {
          part: data,
          cannedServices,
          updatedFields: Object.keys(this.updatedInputStates).filter((key) => {
            try {
              return this.updatedInputStates[key];
            } catch (e) {
              return false;
            }
          }),
        },
      });
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.partBody.nativeElement.scrollTop = this.partBody.nativeElement.scrollHeight + 18;
      } catch (err) {}
    }, 100);
  }

  isPriceCalculated() {
    const isCalculatedPrice = Number(this.calculatedAmount) === Number(this.part.price) || !this.part.price;
    return isCalculatedPrice;
  }

  removeHazmatFee(index) {
    this.hazmatFeeArray.splice(index, 1);
  }

  addAnotherFee() {
    this.hazmatFeeArray.push(this.helperService.deepCopy(this.hazmatFeeObject));
  }

  onROSelect(item, index) {
    this.hazmatFeeArray[index] = item;
    this.itemResults.map((searchList, i) => {
      this.itemResults[i] = searchList.filter((itm) => itm._id !== item._id);
    });
  }

  onSearchClear(index) {
    this.itemResults[index] = [];
  }

  onSearchEnter(query: string) {}

  hazmatFeeSearchSuggestion(query: string, index) {
    this.isSearching = true;
    this.httpService
      .getItems({
        limit: 100,
        search: query.trim(),
        type: 'hazmatFee',
      })
      .then(
        (data: any) => {
          this.itemResults[index] = [];
          if (data.records) {
            if (this.hazmatFeeArray.length > 0) {
              this.itemResults[index] = data.records.filter(({ _id, title }) => !this.hazmatFeeArray.find((fee: any) => fee && fee._id === _id && fee.title === title));
            } else {
              this.itemResults[index] = data.records;
            }
          }
        },
        (err) => {
          this.isSearching = false;
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isSearching = false;
      });
  }

  handleLocationAdd() {
    const ref = this.dialogService.open(LocationAddComponent, {
      styleClass: `add-dialog location-add-dialog `,
      showHeader: false,
      data: {},
    });

    const onClose = ref.onClose.subscribe((data) => {
      if (data && data.isSuccess && data.data && data.data.locationId) {
        this.handleSelect('location', data.data);
      }

      onClose.unsubscribe();
    });
  }

  categoryDropdownSelect(type: string, event: any) {
    const payload: any = { salesCode: event.salesCode };

    if (type === 'category' && event.categoryId) {
      delete this.part.category?.subCategoryId;
      delete this.part.category?.subCategoryName;
      delete this.part.category?.subSubCategoryId;
      delete this.part.category?.subSubCategoryName;
      this.getSubCategories(event);
      this.subCategoriesSuggestions = [];
      this.subCategoriesSuggestionsResults = [];
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = event;
    }

    if (type === 'subCategory' && event.subCategoryId) {
      delete this.part.category?.subSubCategoryId;
      delete this.part.category?.subSubCategoryName;
      this.getSubSubCategories(this.part.category, event);
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = {
        categoryId: this.part.category.categoryId,
        categoryName: this.part.category.categoryName,
      };
      payload.subCategory = event;
    }

    if (type === 'subSubCategory' && event?.subSubCategoryId) {
      payload.category = {
        categoryId: this.part.category.categoryId,
        categoryName: this.part.category.categoryName,
      };
      payload.subCategory = {
        subCategoryId: this.part.category.subCategoryId,
        subCategoryName: this.part.category.subCategoryName,
      };
      payload.subSubCategory = event;
    }

    this.onSelectCategory(payload, '', null);
  }

  getAllCategories() {
    const query: any = { itemType: 'part' };
    this.loader.category = true;
    this.httpService
      .getPricingCategories(query)
      .then((res: any) => {
        this.categoriesSuggestions = res.categories;
        this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
      })
      .finally(() => {
        this.loader.category = false;
      });
  }

  getSubCategories(item) {
    this.loader.subCategory = true;
    this.httpService
      .getPricingSubCategories(item.categoryId, 'part')
      .then((res: any) => {
        if (res && res.subCategories?.length) {
          this.subCategoriesSuggestions = res.subCategories;
          this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
        } else {
          this.subCategoriesSuggestions = [];
          this.subCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subCategory = false;
      });
  }

  getSubSubCategories(item, level2) {
    this.loader.subSubCategory = true;
    this.httpService
      .getPricingSubSubCategories(item.categoryId, level2.subCategoryId, 'part')
      .then((res: any = {}) => {
        if (res && res.subSubCategories?.length) {
          this.subSubCategoriesSuggestions = res.subSubCategories;
          this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestions);
        } else {
          this.subSubCategoriesSuggestions = [];
          this.subSubCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subSubCategory = false;
      });
  }

  checkCategoryOverAndApplyMatrix() {
    let matrixInfo = this.helperService.deepCopy(this.pricings);
    for (let i = 0; i < matrixInfo.length; i++) {
      if (matrixInfo[i]._id === (this.pricing && this.pricing._id)) {
        this.applyMatrix(matrixInfo[i]);
        this.calculateMarkup(true);
        break;
      }
    }
  }

  getPartstechSearch = debounce((partNumber?) => {
    // if(this.selectedValue) return
    this.partstechResults = [];
    // this.othersResults = [];

    this.httpService.getPartstechSearch(partNumber).then((res: any) => {
      if (res.data.length >= 0) {
        this.partstechResults = res.data;

        if (this.partstechResults?.length && this.partstechResults?.length === 1) {
          const { itemInfo } = this.partstechResults[0];

          if (this.part.name === '') {
            this.handleChange('name', itemInfo?.partName);
          }

          if (!this.isCustomerCategory) {
            this.onSelectCategory(this.partstechResults[0], '');
            this.selectedValue = '';
          }
        } else {
          // this.focus.classificationSearch = true;
        }

        if (this.part.category?.categoryName) {
          // const customCategory = { ...this.part.customCategory };
          // if (customCategory.subSubCategory) customCategory.subSubCategory.salesCode = this.part.salesCode;
          // else if (customCategory.subCategory) customCategory.subCategory.salesCode = this.part.salesCode;
          // else if (customCategory.category) customCategory.category.salesCode = this.part.salesCode;
          // this.onSelectCategory(customCategory, 'parthTechcategory', null);
          this.checkPricingBackwardCompatibility();
        }
      } else {
        this.partstechResults = [];
      }
    });
  }, 800);

  getPartstechCategoryTitle(item, query?) {
    let title = '';
    if (query && query.length >= 2) {
      if (item?.subSubCategories || item?.subSubCategory) {
        const higlight = `<span class="secondary-900 font-500">${this.formatService.highlightedPartstechText(
          item?.subSubCategories?.subSubCategoryName || item?.subSubCategory?.subSubCategoryName,
          query,
        )}</span>`;
        if (item.category) title += `${item?.category?.categoryName}`;
        if (item.subCategory) title += ` > ${item?.subCategory?.subCategoryName}`;
        if (item.subSubCategory) title += ` > ${higlight}`;
        if (item.subSubCategories) title += ` > ${higlight}`;
      } else if (item?.subCategory) {
        const higlight = `<span class="secondary-900 font-500">${this.formatService.highlightedPartstechText(item?.subCategory?.subCategoryName, query)}</span>`;
        if (item.category) title += `${item?.category?.categoryName}`;
        if (item.subCategory) title += ` > ${higlight}`;
        if (item.subSubCategory) title += ` > ${item?.subSubCategory?.subSubCategoryName}`;
        if (item.subSubCategories) title += ` > ${item?.subSubCategories?.subSubCategoryName}`;
      } else if (item?.category) {
        const higlight = `<span class="secondary-900 font-500">${this.formatService.highlightedPartstechText(item?.category?.categoryName, query)}</span>`;
        if (item.category) title += `${higlight}`;
        if (item.subCategory) title += ` > ${item?.subCategory?.subCategoryName}`;
        if (item.subSubCategory) title += ` > ${item?.subSubCategory?.subSubCategoryName}`;
        if (item.subSubCategories) title += ` > ${item?.subSubCategories?.subSubCategoryName}`;
      }
    } else {
      if (item.category) title += `${item?.category?.categoryName}`;
      if (item.subCategory) title += ` > ${item?.subCategory?.subCategoryName}`;
      if (item.subSubCategory) title += ` > ${item?.subSubCategory?.subSubCategoryName}`;
      if (item.subSubCategories) title += ` > ${item?.subSubCategories?.subSubCategoryName}`;
    }
    return title;
  }

  onClearCategorySuggestion(type) {
    this.selectedValue = '';
    if (this.part.number && this.isNewCategoriesEnabled) {
      this.getPartstechSearch(this.part.number);
    }
  }

  openConfirmationDialog(salesCode: any) {
    let title: string = 'Confirmation';
    let message: string =
      'Updating the item classification will also auto-update the Sales Code based on the new item classification. If a Sales Code was previously assigned to this item, it will be replaced with the new sales code. Are you sure you want to proceed?';
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-18 font-700',
        title: title,
        message: message,
        button: {
          success: { title: 'Proceed' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.part.salesCode = salesCode;
        //this.salesCodeOverideConfirm = true;
      }
      onClose.unsubscribe();
    });
  }

  onSelectCategory(event: any, type: string, close: any = null, index: number = null, isOtherRecord = false) {
    const { category, salesCode, isAutoAssign } = this.helperService.onCategorySelect(event, this.part.salesCode?.salesCodeId);

    this.part.category = category;
    if (this.part.salesCode?.salesCodeId && salesCode?.salesCodeId !== this.part.salesCode?.salesCodeId) {
      this.openConfirmationDialog(salesCode);
    } else {
      this.part.salesCode = salesCode;
    }

    this.isAutoAssign = isAutoAssign;

    if (event?.category) {
      if (isOtherRecord) {
        this.selectedLevel = `${event?.category?.categoryId}${index}-`;
      } else {
        this.selectedLevel = `${event?.category?.categoryId}${index}`;
      }
      this.selectedValue = '';

      if (type === 'parthTechcategory') {
        this.part.category.name = this.getPartstechCategoryTitle(event);
      }

      if (close) close();
    }
  }

  searchCategorySuggestion = debounce((event, pageIndex: number = 0) => {
    // if (!event) return;
    this.partsTechPageIndex = pageIndex;
    this.partstechResults = [];
    this.othersResults = [];
    // this.selectedValue = event;
    const query: any = {
      itemType: 'part',
      limit: this.limit,
      skip: pageIndex * this.limit,
    };

    if (event) query.searchTerm = encodeURI(event);
    this.isDataLoading = true;
    this.httpService.getSearchPricingCategories(query).then((res: any) => {
      if (res?.categories[0] && res?.categories[0].metaData) {
        this.totalRecords = res?.categories[0].metaData.totalRecords;
      }
      if (res?.categories[0] && res?.categories[0].records) {
        this.partstechResults = res?.categories[0].records.filter((data) => data.priority);
        this.partstechResults = this.partstechResults.sort((a, b) => parseFloat(a.priority) - parseFloat(b.priority));
        this.othersResults = res?.categories[0].records.filter((data) => !data.priority);
        this.othersResults = this.sortResults(this.selectedValue, this.othersResults);
      }
      this.isDataLoading = false;
    });
  }, 1000);

  sortResults(searchQuery, results) {
    const exactMatches = [];
    const partialMatches = [];
    let normalizedQuery = searchQuery.toLowerCase();
    normalizedQuery = normalizedQuery.replace(/%20/g, ' ');

    results.forEach((item) => {
      const normalizedItem = item?.searchTerm?.toLowerCase().includes(normalizedQuery);

      if (normalizedItem) {
        exactMatches.push(item);
      } else {
        partialMatches.push(item);
      }
    });
    return exactMatches.concat(partialMatches);
  }

  onScroll = debounce((event, pageIndex: number = 0) => {
    if (this.othersResults?.length + this.partstechResults?.length < this.totalRecords) {
      const element = event.target;
      if (element.scrollHeight - element.scrollTop - element.clientHeight < 10) {
        if (!this.selectedValue) return;
        this.isDataLoading = true;
        let partsTechdata = [];
        let othersData = [];

        this.partsTechPageIndex = this.partsTechPageIndex + 1;
        const query: any = {
          itemType: 'part',
          limit: this.limit,
          skip: this.partsTechPageIndex * this.limit,
        };
        if (element.scrollHeight - element.scrollTop - element.clientHeight < 10) {
          if (this.selectedValue) query.searchTerm = encodeURI(this.selectedValue);
          this.httpService.getSearchPricingCategories(query).then((res: any) => {
            if (res?.categories[0] && res?.categories[0].metaData) {
              this.totalRecords = res?.categories[0].metaData.totalRecords;
            }
            if (res?.categories[0] && res?.categories[0].records) {
              partsTechdata = res?.categories[0].records.filter((data) => data.priority);
              othersData = res?.categories[0].records.filter((data) => !data.priority);
            }

            this.partstechResults = [...this.partstechResults, ...partsTechdata];
            this.partstechResults = this.partstechResults.sort((a, b) => parseFloat(a.priority) - parseFloat(b.priority));
            this.othersResults = [...this.othersResults, ...othersData];
            this.othersResults = this.sortResults(this.selectedValue, this.othersResults);
            this.isDataLoading = false;
          });
        }
      }
    }
  }, 300);

  handleSearchValue(value) {
    this.selectedValue = value;
  }

  onTabSelect(event) {
    this.selectedTab = event?.index;
    if (this.selectedTab === 1) {
      this.getLogs();
    }
  }

  renderSuggestions() {
    return [...this.partstechResults, ...this.othersResults];
  }

  openQtyOnEstimateModal() {
    const name = this.part?.name || this.part?.titleFR || 'N/A';
    this.dialogService.open(QtyOnEstimateListModalComponent, {
      width: '1150px',
      styleClass: 'add-dialog qty-stock-list-modal',
      showHeader: false,
      data: {
        name,
        itemId: this.partId,
      },
    });
  }

  isCostEditable() {
    if (this.isAttributeBasedPricingEnable && !this.isPricingManagementEnable) {
      return true
    } else if(this.isPartsOrderingItem) {
      return true;
    } else if((this.part?.costType === 'avg' || this.part?.costType === 'latestPo') && this.part?.stocked && !this.isOpenFromRO) {
      return true;
    } else if(this.isPricingManagementEnable && !this.pricingPrivilege?.permitted && !this.isOpenFromPO && !this.isOpenFromRO) {
      return true;
    } else {
      return false;
    }
  }
}
